export const types = {
  SET_THEME: 'SET_THEME',
  LOG_OUT: 'LOG_OUT',
  CLEAR_TOKEN: 'CLEAR_TOKEN',
  SET_USER_ROLES: 'SET_USER_ROLES',
  GET_USER_ROLES: 'GET_USER_ROLES',
  SET_SERVER_PROPERTIES: 'SET_SERVER_PROPERTIES',
  GET_SERVER_PROPERTIES: 'GET_SERVER_PROPERTIES',
  SET_APP_ERROR:'SET_APP_ERROR',
  CHANGE_LOCALE: 'CHANGE_LOCALE',
  SET_VIDEO_CHAT_V2_IN_MEETING: 'SET_VIDEO_CHAT_V2_IN_MEETING',
};

export function setTheme(theme) {
  return {
    type: types.SET_THEME,
    theme,
  };
}

export function logOut(data) {
  return {
    type: types.LOG_OUT,
    data,
  };
}

export function clearToken(options) {
  return {
    type: types.CLEAR_TOKEN,
    options,
  };
}
export function setUserRoles(roles) {
  return {
    type: types.SET_USER_ROLES,
    userRoles: roles,
  };
}

export function getUserRoles() {
  return {
    type: types.GET_USER_ROLES,
  };
}
export function setServerProperties(properties) {
  return {
    type: types.SET_SERVER_PROPERTIES,
    properties,
  };
}

export function getServerProperties() {
  return {
    type: types.GET_SERVER_PROPERTIES,
  };
}
export function setAppError(error){
  return {
    type: types.SET_APP_ERROR,
    error
  }
}

export const changeLocale = (locale) => ({
  type: types.CHANGE_LOCALE,
  locale,
});

export const setVideoChatV2InMeeting = (inMeeting) => ({
  type: types.SET_VIDEO_CHAT_V2_IN_MEETING,
  inMeeting: Boolean(inMeeting),
});